export default [{
  path: '/view/usersctivities',
  name: 'useractivities',
  component: () => import('@/app/user-activities/UserActivities'),
  meta: {
    resource: 'useractivities',
    actions: ['read']
  }
}]
